import React, {useEffect} from 'react';
import useListing from './useListing';
import styles from "./Listing.module.scss"
import Filters from "../../components/ui/Filters/Filters";
import FiltersMobile from "../../components/ui/FitlersMobile/FiltersMobile";
import Pagination from "../../components/ui/Pagination/Pagination";
import TabContent from "../../components/ui/TabContent/TabContent"
import mapping from "../../config/mapping";
import Sorting from "../../components/ui/Sorting/Sorting";
import useFilters from "../../hooks/useFilters";

const Listing = () => {
    const {
        screenWidth,
        handleSelectionClick,
        selectedTabOption,
        handleLearnMore,
        totalPages,
        displayPages,
        currentPage,
        handlePageChange,
        handleNext,
        handlePrevious,
        selectedProductsPerPage,
        selectedProductsSorting,
        setSelectedProductsPerPage,
        setSelectedProductsSorting,
        setCurrentPage,
        search,
        isMobile,
        onPageChange,
        labels,
        searchQuery,
        devices,
        articles,
        support,
        rateplans,
        filterItems,
        setDisplayPages,
        updateURL,
        parametersReady,
        filtersForRequest,
        expandedSubCategories,
        setExpandedSubCategories,
        promotionDevices,
        promoProductsReady,
        callSearchHubForPromotionalProducts,
        onPriceChange,
        minPriceRange,
        maxPriceRange,
        AfterPriceChange,
        minPrice,
        maxPrice,
        categoryNameList,
        lang,
        productSorting
    } = useListing();

    const {
        filterRef,
        showMobileFilter,
        setShowMobileFilter,
        SelectedItem,
        handleShowFilterSection,
        expandedCategories,
        toggleSubCategoryExpansion,
        toggleCategoryExpansion,
        clearFilters,
        selectedOptions,
        filters,
        handleFilterOptionChange,
        handleRemoveFilterOption,
        handleRadioFilterOptionChange,
        filtersReady,
        toggleCategorySelection,
        isCheckboxVisible
    } = useFilters(isMobile, setCurrentPage, filtersForRequest, parametersReady, expandedSubCategories, setExpandedSubCategories, null, true);


    useEffect(() => {
        callSearchHubForPromotionalProducts();
    }, [])

    useEffect(() => {
        if (parametersReady && filtersReady && promoProductsReady) {
            search(filters, false);
        }
    }, [selectedProductsPerPage, selectedProductsSorting, currentPage, selectedTabOption, parametersReady, searchQuery, filters])

    const itemsMap = mapping.getItemsMap(devices, rateplans, articles, support);

    return (
        <>
            <div className={styles['container']}>

                <FiltersMobile
                    isMobile={isMobile}
                    filterRef={filterRef}
                    showMobileFilter={showMobileFilter}
                    setShowMobileFilter={setShowMobileFilter}
                    SelectedItem={SelectedItem}
                    selectedTabOption={selectedTabOption}
                    clearFilters={clearFilters}
                    selectedOptions={selectedOptions}
                    expandedSubCategories={expandedSubCategories}
                    expandedCategories={expandedCategories}
                    filterItems={filterItems}
                    toggleCategoryExpansion={toggleCategoryExpansion}
                    toggleSubCategoryExpansion={toggleSubCategoryExpansion}
                    handleShowFilterSection={handleShowFilterSection}
                    handleRemoveFilterOption={handleRemoveFilterOption}
                    toggleCategorySelection={toggleCategorySelection}
                    handleFilterOptionChange={handleFilterOptionChange}
                    handleRadioFilterOptionChange={handleRadioFilterOptionChange}
                    isCheckboxVisible={isCheckboxVisible}
                />

                <div>
                    {categoryNameList && (
                        <span className="listing_page_main_title override_title_suffix fw_bolder">
                                {categoryNameList[categoryNameList.length - 1]}
                            {(devices.count || rateplans.count) && (
                                <span className="override_title_suffix">
                                    ({devices.count > 0 ? devices.count : rateplans.count })
                                </span>
                            )}
                            </span>
                    )}

                    <div className="d-flex flex-wrap">
                        {/* LEFT */}
                        <Filters
                            selectedTabOption={selectedTabOption}
                            devices={devices}
                            rateplans={rateplans}
                            handleLearnMore={handleLearnMore}
                            screenWidth={screenWidth}
                            handleShowFilterSection={handleShowFilterSection}
                            clearFilters={clearFilters}
                            selectedOptions={selectedOptions}
                            expandedSubCategories={expandedSubCategories}
                            expandedCategories={expandedCategories}
                            filterItems={filterItems}
                            toggleSubCategoryExpansion={toggleSubCategoryExpansion}
                            toggleCategoryExpansion={toggleCategoryExpansion}
                            handleRemoveFilterOption={handleRemoveFilterOption}
                            handleFilterOptionChange={handleFilterOptionChange}
                            handleRadioFilterOptionChange={handleRadioFilterOptionChange}
                            toggleCategorySelection={toggleCategorySelection}
                            isCheckboxVisible={isCheckboxVisible}
                            isFromListing={true}
                            onPriceChange={onPriceChange}
                            minPriceRange={minPriceRange}
                            maxPriceRange={maxPriceRange}
                            AfterPriceChange={AfterPriceChange}
                            minPrice={minPrice}
                            maxPrice={maxPrice}
                            lang={lang}
                        />

                        <div
                            className={(screenWidth < 1200 || selectedTabOption === 'articles' || selectedTabOption === 'support') ? "navigation-menu-wrap" : "cards-elements"}>

                            <Sorting screenWidth={screenWidth}
                                     selectedTabOption={selectedTabOption}
                                     devicesItems={devices}
                                     rateplansItems={rateplans}
                                     articlesItems={articles}
                                     supportItems={support}
                                     isMobile={isMobile}
                                     currentPage={currentPage}
                                     setCurrentPage={setCurrentPage}
                                     search={search}
                                     handleShowFilterSection={handleShowFilterSection}
                                     updateURL={updateURL}
                                     selectedProductsPerPage={selectedProductsPerPage}
                                     selectedProductsSorting={selectedProductsSorting}
                                     setSelectedProductsSorting={setSelectedProductsSorting}
                                     setSelectedProductsPerPage={setSelectedProductsPerPage}
                                     productSorting={productSorting}
                            />

                            {itemsMap && itemsMap[selectedTabOption] && (
                                <TabContent
                                    selectedTabOption={selectedTabOption}
                                    items={itemsMap[selectedTabOption]}
                                    onLearnMore={handleLearnMore}
                                    labels={labels}
                                    isFromListing = {true}
                                    promotionDevices = {promotionDevices}
                                />
                            )}

                            {totalPages.length > 1 &&
                                <Pagination
                                    displayPages={displayPages}
                                    onPageChange={onPageChange}
                                    currentPage={currentPage}
                                    totalPages={totalPages}
                                    setDisplayPages={setDisplayPages}
                                    handlePageChange={handlePageChange}
                                    handleNext={handleNext}
                                    handlePrevious={handlePrevious}
                                />
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Listing;
